//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import {
  MAINTAB_CREDIT_KEY,
  DOCUMENT_VIEW_LINK,
  FINANCE_APPLICATION_TAB_ASSET_DETAILS_KEY,
} from '~/constants/applications'
import { changeRoute } from '~/helpers/changeRoute'
import { toCurrency } from '@/helpers/currency'
import { format } from 'date-fns'
import { makeCapitalCase } from '~/helpers/common'
import PicklesInspectionViewDialog from './UtilComponents/PicklesInspectionViewDialog.vue'
import { validatePositiveNumber } from '~/helpers/validators'
export default {
  components: {
    PicklesInspectionViewDialog,
  },
  props: {
    sharedData: {
      type: Object,
      default: () => ({}),
    },
    primaryData: {
      type: Object,
      default: () => ({}),
    },
    isCommercial: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      format,
      makeCapitalCase,
      toCurrency,
      DOCUMENT_VIEW_LINK,
      MAINTAB_CREDIT_KEY,
      inspectionDialog: false,
      isLoadingPicklesValuation: true,
      latestTradeInValuation: null,
      inspectionData: null,
      isSubmitting: false,
      formData: {
        customerEstimatedTradeInValue: null,
        financeOwing: null,
        consentCheckbox: false,
      },
      formRules: {
        customerEstimatedTradeInValue: [
          {
            required: true,
            validator: this.checkNumberValue,
            message: 'Customer estimated trade in value is required',
            trigger: 'blur',
          },
        ],
        consentCheckbox: [
          {
            required: true,
            message: 'You must get consent from the customer',
            trigger: 'change',
          },
          { validator: this.validateConsent, trigger: 'change' },
        ],
      },
      formRulesExists: {
        consentCheckbox: [
          {
            required: true,
            message: 'You must get consent from the customer',
            trigger: 'change',
          },
          { validator: this.validateConsent, trigger: 'change' },
        ],
      },
    }
  },
  mounted() {
    this.getLatestValuation().then(() => {
      this.getInspection()
    })
    this.$nuxt.$on('closeInspectionDialog', () => {
      this.inspectionDialog = false
    })
  },
  beforeDestroy() {
    this.$nuxt.$off('closeAssetDialog')
    this.$nuxt.$off('closeInspectionDialog')
  },
  computed: {
    getTradeInBalance() {
      const tradeInVehicle = this.sharedData?.tradeIn?._id ?? ''
      const liabilities = this.primaryData?.liabilities ?? []
      const tradeInLiabilities = liabilities.filter(
        (l) => l.vehicle === tradeInVehicle
      )
      if (tradeInLiabilities.length) {
        return tradeInLiabilities[0].outstandingAmount
      }
      return null
    },
  },
  methods: {
    validateConsent(rule, value, callback) {
      if (!value) {
        callback(new Error('You must get consent from the customer'))
      } else {
        callback()
      }
    },
    checkNumberValue(_rule, value, callback) {
      validatePositiveNumber(value, callback)
    },
    async submitTradeInForm(submitOnly = false) {
      try {
        if (!submitOnly) {
          await this.$refs.tradeInForm.validate()
        } else {
          await this.$refs.tradeInFormExists.validate()
        }
        this.isSubmitting = true

        const { id, applicationId } = this.$route.params

        await this.$store.dispatch('applications/createTradeInVehicle', {
          id,
          applicationId,
          ...(!submitOnly
            ? {
                customerEstimatedTradeInValue:
                  this.formData.customerEstimatedTradeInValue,
                financeOwing: this.formData.financeOwing || 0,
              }
            : {}),
          wantsPicklesAppraisal: true,
        })
      } catch (error) {
        if (error !== false) {
          // validation error returns false
          console.error('Error submitting trade in form:', error)
        }
      } finally {
        this.isSubmitting = false
      }
    },
    numberWithCommas(x) {
      return toCurrency(x)
    },
    async getLatestValuation() {
      this.isLoadingPicklesValuation = true
      const { id } = this.$route.params
      if (
        this.sharedData?.tradeIn?.wantsPicklesAppraisal &&
        this.sharedData.tradeIn.contactSentToPicklesDate
      ) {
        const response = await this.$store.dispatch(
          'applications/getTradeInVehicleValuation',
          { vrgId: id }
        )
        this.latestTradeInValuation = response?.data?.valuation
      }
      this.isLoadingPicklesValuation = false
    },
    async getInspection() {
      if (this.latestTradeInValuation) {
        const { id } = this.$route.params
        const response = await this.$store.dispatch(
          'applications/getTradeInVehicleInspection',
          { vrgId: id, guid: this.latestTradeInValuation.inspectionGuid }
        )
        this.inspectionData = response.data
      }
    },
    async nextPage() {
      if (this.isCommercial) {
        if (!this.sharedData?.securedFinance) {
          return this.$nuxt.$emit('changeTab', {
            tab: FINANCE_APPLICATION_TAB_LOAN_DETAILS_KEY,
          })
        }
        return this.$nuxt.$emit('changeTab', {
          tab: FINANCE_APPLICATION_TAB_ASSET_DETAILS_KEY,
        })
      }
      const { id, applicationId } = this.$route.params
      const nextTab = !this.sharedData?.securedFinance
        ? 'loanDetails'
        : 'assetDetails'
      await changeRoute({
        route: this.$route,
        router: this.$router,
        path: `/finance/applications/${id}/${applicationId}`,
        query: {
          maintab: nextTab,
        },
      })
      this.$nuxt.$emit('updateComponent', nextTab)
    },
    async backToPrevious() {
      if (this.isCommercial) {
        return this.$nuxt.$emit('changeTab', {
          tab: MAINTAB_CREDIT_KEY,
        })
      }
      await changeRoute({
        route: this.$route,
        router: this.$router,
        query: { ...this.$route.query, maintab: MAINTAB_CREDIT_KEY },
      })
      this.$nuxt.$emit('updateComponent', MAINTAB_CREDIT_KEY)
    },
    openViewInspectionDetail() {
      this.inspectionDialog = true
    },
  },
}
